<template>
  <Navbar2 />
  <!-- Breadcrumb Area  -->
  <div class="breadcrumb-area services section-padding light-bg-1 pb-0">
    <div class="container">
      <div class="row">
        <div
          class="offset-xl-3 col-xl-6 offset-lg-3 col-lg-6 offset-md-3 col-md-6 col-12 text-center"
        >
          <div class="section-title">
            <p>FAQ</p>
            <h2>Frequently Asked Questions</h2>
          </div>
        </div>
      </div>

      <div class="row mt-90">
        <div class="col-12">
          <div class="bread-bg">
            <img src="/assets/img/breadcrumb/service_banner.jpg" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>

  <FAQ1 :className="false" />
  <ContactComponent />
  <Footer2 />
</template>
<script>
import Navbar2 from "@/components/Navbar2.vue";
import ContactComponent from "@/components/ContactComponent.vue";
import Footer2 from "@/components/Footer2.vue";
import axios from "axios";
import FAQ1 from "@/components/faq/FAQ1.vue";
export default {
  name: "FAQ",
  components: {
    ContactComponent,
    Navbar2,
    Footer2,
    FAQ1,
  },
  data() {
    return {
      faqs: [],
    };
  },
  async beforeMount() {
    let fetchedData = await axios.get("/assets/data/faq.json");
    this.faqs = fetchedData.data.faq;
  },
  mounted() {
    // Add structured data (JSON-LD) for SEO
    this.addStructuredData();
    // data-backround

    $("[data-background]").each(function () {
      $(this).css(
        "background-image",
        "url( " + $(this).attr("data-background") + "  )"
      );
    });

    //jQuery Animation
    new WOW().init();

    //Magnific Pop-up

    $(".video-play-btn").magnificPopup({
      type: "iframe",
    });
  },
  methods: {
    addStructuredData() {
      // FAQPage structured data with FAQ items
      const faqPageData = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "name": "Frequently Asked Questions - Afino Tax Consultants",
        "description": "Find answers to common questions about Corporate Tax, VAT, Accounting, and Business Advisory services in Dubai, UAE.",
        "url": "https://www.afinotax.com/faq",
        "mainEntity": this.faqs.map(faq => ({
          "@type": "Question",
          "name": faq.question,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": faq.answer
          }
        }))
      };

      const script = document.createElement('script');
      script.id = 'structured-data-faq';
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(faqPageData);
      document.head.appendChild(script);
    }
  },
  beforeUnmount() {
    const script = document.getElementById('structured-data-faq');
    if (script) script.remove();
  },
};
</script>
